import Modal from '@Components/Shared/Modals/Modal';
import translator from '@Components/Utilities/Translator';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import { useState } from 'react';
import LoadingRing from '@Components/MuiWrappers/LoadingRing';
import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';

const ConsignmentRequestConfirmationModal = (props) => {
    const {
        consignmentRequestModel,
        onClose,
    } = props;

    const [isLoading, setIsLoading] = useState(false);
    const [isDeleted, setIsDeleted] = useState(false);
    const routes = useRecoilValue(atoms.routes);
    const [userError, setUserError] = useState(false);
    const [userErrorMessage, setUserErrorMessage] = useState('');

    const closeModal = () => {
        onClose();
        if (isDeleted) {
            window.location.reload();
        }
    };

    const confirmDeletion = () => {
        if (consignmentRequestModel && !isLoading) {
            setIsLoading(true);
            sandhillsRequest({
                url: routes.DeleteConsignmentRequest,
                method: 'post',
                data: {
                    EquipmentMessageId: consignmentRequestModel.Request.EquipmentMessageID
                },
                errorHandling: {
                    message: 'Error deleting consignment request. Please refresh your page.',
                    showDetails: true,
                    useConsole: true,
                    useAlert: false
                }
            }).then((data) => {
                setIsLoading(false);
                if (data && data.Success) {
                    setIsDeleted(true);
                } else {
                    setUserError(true);
                    setUserErrorMessage("Error deleting consignment request. Please refresh your page.");
                }              
            }).catch((error) => {
                setUserError(true);
                setIsLoading(false);
                setUserErrorMessage("Error deleting consignment request. Please refresh your page.");
            });
        }
    }

    return (
        <Modal containerClassName='consignment-request-confirmation-modal' onEscapeKeyClose={closeModal}>
            <Modal.Header onClose={closeModal}>
                <div className="top-row">
                    <Modal.Title headingClassName='show-all-modal-title'>
                        {translator.translate('sandhills.youhavechoosentodeletethislisting')}
                    </Modal.Title>
                </div>
            </Modal.Header>
            <Modal.Body>
                {isDeleted ? (
                    <p>
                        {translator.translate('sandhills.quoterequestdeleted')}
                    </p>
                ) : (
                    <p>
                        <strong>{translator.translate('sandhills.industry')}:</strong> {props.consignmentRequestModel.BaseCategory}
                        <br />
                        <strong>{translator.translate('sandhills.category')}:</strong> {props.consignmentRequestModel.Category}
                        <br />
                        <strong>{translator.translate('sandhills.manufacturer')}:</strong> {props.consignmentRequestModel.Request.Manufacturer}
                        <br />
                        <strong>{translator.translate('sandhills.year')}:</strong> {props.consignmentRequestModel.Request.EquipmentYear}
                        <br />
                        {props.consignmentRequestModel.Request.PreferredSaleDate &&
                            <>
                                <strong>{translator.translate('sandhills.preferredsaledate')}:</strong> {new Date(props.consignmentRequestModel.Request.PreferredSaleDate).toLocaleDateString(undefined, {
                                    year: 'numeric',
                                    month: 'short',
                                    day: 'numeric'
                                })}
                            </>
                            }
                            <br />
                            <br />
                            <a className='consignment-request-button' onClick={confirmDeletion}>{translator.translate('sandhills.confirm')}</a>
                    </p>
                )}
                {userError && <p className='error'>{userErrorMessage}</p>}
            </Modal.Body>
            <Modal.Footer>
                {isLoading && <LoadingRing />}
            </Modal.Footer>
        </Modal>
    );
}

export default ConsignmentRequestConfirmationModal;